<template>
  <div id="login">
    <el-row type="flex" class="row-bg" justify="center">
      <label class="title">深圳慧源Cloud后台管理系统</label>
    </el-row>
    <div id="loginContent">
      <el-row id="loginRow">
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="username">
            <el-input class="loginInputU" prefix-icon="icon el-icon-user-solid"
                      type="text" v-model="loginForm.username"
                      auto-complete="off" placeholder="请输入账号"/>
          </el-form-item>
          <el-form-item prop="password" >
            <el-input  class="loginInputP" prefix-icon="icon el-icon-s-cooperation"
                      type="password" v-model="loginForm.password" @keyup.enter.native="submitForm('')"
                      auto-complete="off" show-password placeholder="请输入密码"/>
          </el-form-item>
          <el-form-item prop="validate">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-input id="loginCode" v-model="loginForm.validate" oninput="value=value.replace(/[^\d]/g,'')"
                          maxLength='4' clearable placeholder="验证码"></el-input>
              </el-col>
              <el-col :span="4">
                <div class="code" @click="refreshCode">
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div>
              </el-col>
              <el-col :span="9">
                <el-checkbox v-model="loginForm.remember" id="loginRemember">记住密码</el-checkbox>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button id="loginBtn" type="primary" round  @click="submitForm()">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Encrypt, Decrypt } from '../api/ucrypto'
export default {
  name: 'Login',
  data () {
    return {
      identifyCodes: '1234567890',
      identifyCode: '',
      errorInfo: false,
      msg: 'Welcome to Cloud APk Manager System',
      loginForm: {
        username: '',
        password: '',
        validate: '',
        remember: false
      },
      rules: {
        username: [{required: true, message: '请输入用户名', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
        validate: [{required: true, message: '请输入验证码', trigger: 'blur'}]
      }
    }
  },
  created () {
    if (this.$cookie.get('remember') === 'remember') {
      this.loginForm.username = this.$cookie.get('userName')
      this.loginForm.password = this.$cookie.get('userPassword')
      this.loginForm.password = Decrypt(this.loginForm.password)
      this.loginForm.remember = true
    } else {
      this.loginForm.remember = false
    }
  },
  mounted () {
    this.identifyCode = ''
    this.makeCode(this.identifyCode, 4)
  },
  methods: {
    submitForm () {
      const self = this
      let tmpPassword = Encrypt(this.loginForm.password)
      if (self.loginForm.remember) {
        this.$cookie.set('userName', self.loginForm.username, 30)
        this.$cookie.set('userPassword', tmpPassword, 30)
      } else {
        this.$cookie.set('userName', '', 0)
        this.$cookie.set('userPassword', '', 0)
      }
      let check = self.loginForm.remember ? 'remember' : ''
      this.$cookie.set('remember', check, 30)
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          if (self.loginForm.validate !== this.identifyCode) {
            self.errorInfo = true
            self.errInfo = '验证码错误'
            self.$message.error('验证码错误')
            this.refreshCode()
          } else {
            this.$axios({
              url: this.$global.baseURL.concat('login'),
              method: 'post',
              data: {username: this.loginForm.username, password: tmpPassword}
            }).then(successResponse => {
              if (successResponse.data.code === 200) {
                let token = successResponse.data.data.token
                let userId = successResponse.data.data.userId
                // 将返回的用户信息和令牌写入localStorage
                localStorage.setItem('token', token)
                localStorage.setItem('userId', userId)
                this.$router.replace({path: '/main'})
              } else if (successResponse.data.code === -500) {
                self.errorInfo = true
                self.errInfo = '用户不存在'
                self.$message.error('用户不存在')
                this.refreshCode()
                this.loginForm.validate = ''
              } else if (successResponse.data.code === -501) {
                self.errorInfo = true
                self.errInfo = '密码错误'
                self.$message.error('密码错误')
                this.refreshCode()
                this.loginForm.validate = ''
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCode, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
      console.log(this.identifyCode)
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  .title{
    color: aliceblue;
    position: relative;
    margin-top: 10%;
    text-align: center;
    font-size: 30px;
  }
  #loginRemember{
    margin-left: 80%;
  }
  #loginRow{
    padding-left: 7%;
    padding-right: 7%;
    padding-top: 5%;
  }
  .loginInputU{
    margin-top: 4%;
  }
  .loginInputP{
    margin-top: 2%;
  }
  #loginBtn{
    margin-top: 0;
    width: 100%;
  }
  #login{
    background: url("../../static/bg.png") no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
  }
  #loginContent{
    text-align: center;
    margin: 0 auto;
    position: relative; /*设置position属性*/
    top: 5%;
    background: #ffffff;
    width: 30%;
    min-width: 600px;
    min-height: 320px;
    height: 36%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    border-radius: 30px;
  }
  h1, h2 {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue